import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineLanguage } from "react-icons/hi2";
import "./LanguageSwitcher.css";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const isArabic = i18n.language?.startsWith("ar");
  const nextLang = isArabic ? "en" : "ar";
  const label = isArabic ? "EN" : "العربية";

  const handleToggle = () => {
    i18n.changeLanguage(nextLang);
  };

  return (
    <button
      type="button"
      className="lk-lang-toggle"
      onClick={handleToggle}
      aria-label={`Switch language to ${nextLang === "ar" ? "Arabic" : "English"}`}
    >
      <HiOutlineLanguage className="lk-lang-icon" />
      <span className="lk-lang-text">{label}</span>
    </button>
  );
}
